import {requestGet, requestPost} from '@/utils/request';

const api = {
    LIST: '/content/moment_list',
    ADD: '/content/moment_add',
	DEL: '/content/moment_del',
	DETAIL: '/content/moment_detail',
	
	ADD_LIKE: '/content/moment_add_like',
	ADD_COMMENT: '/content/moment_add_comment',
	
}

export async function momentList(queryParams) {
    return requestGet(api.LIST, queryParams);
}

export async function momentAdd(form) {
    return requestPost(api.ADD, form);
}

export async function momentDel(id) {
	let params = {id: id};
    return requestGet(api.DEL, params);
}

export async function momentAddLike(form) {
    return requestPost(api.ADD_LIKE, form);
}

export async function momentAddComment(form) {
    return requestPost(api.ADD_COMMENT, form);
}

export async function momentDetail(id) {
	let params = {id: id};
    return requestGet(api.DETAIL, params);
}

